import { ZodSchema, ZodTypeDef } from 'zod/v3';

export const transformNullish = <
  O,
  I = O,
  S extends ZodSchema<O, ZodTypeDef, I | null | undefined> = ZodSchema<
    O,
    ZodTypeDef,
    I | null | undefined
  >,
>(
  schema: S,
  defaultValue: O,
) => schema.nullish().transform<O>((v) => v ?? defaultValue);
